$(".pass-toggle").click(function () {
    if($(this).hasClass("_active")){
        $(this).removeClass("_active")
        $(this).siblings("input").attr("type","password")
    } else{
        $(this).addClass("_active")
        $(this).siblings("input").attr("type","text")
    }
})

$(".favourite-btn").click(function () {
    $(this).toggleClass("_active")
})


$(document).on('click', '.rating-input__item', function(e) {
    let ratingItem = parseInt($(this).attr("data-rating-value"))
    $(this).parent(".rating-input").attr("data-total-rating", ratingItem)
    $(this).siblings(".rating-input__field").val(ratingItem)
})

$(window).scroll(function() {
    if ($(window).scrollTop() > 100) {
        $(".scroll-up").addClass("scroll-up--active")
    } else {
        $(".scroll-up").removeClass("scroll-up--active")
    }
})

$(".scroll-up").click(function() {
    $(window).scrollTop(0);
})

function renderLinksSelect(){
    $(".search-links .search-links__current").html($(".search-links__item._active").html())
}
renderLinksSelect()

$(document).on('click', '.search-links__current', function(e) {
    $(this).toggleClass("_active")
})



$(document).mouseup( function(e){
    var div = $( ".search-links" );
    if ( !div.is(e.target)
        && div.has(e.target).length === 0 ) {
        if($(".search-links__current").hasClass("_active")){
            $(".search-links__current").removeClass("_active")
        }
    }
});


$("._close-cookie").click(function() {
    $(".cookie-modal").removeClass("_active")
})
